import {VerificationStatus} from "entities/user/model/types";

export enum AccStatus {
    Active = 'active',
    Inactive = 'inactive',
    Closed = 'closed',
}

type Person = {
    id: string;
    address: string;
    email: string;
    birthdate: string;
    city: string;
    country: string;
    updated: string;
    created: string;
    nationality: string;
    is_us_related: string;
    additional_income_source: string;
    additional_document_type: string;
    is_archived: string;
    income_source: string;
    additional_document_country: string;
    document_expire_date: string;
    birth_country: string;
    client_info_checker_id: string;
    additional_document_comment: string;
    bank_services: string;
    data_correctness_confirmation: string;
    last_name: string;
    document_type: string;
    document_number: string;
    first_name: string;
    is_pep_related: string;
    phone_number: string;
    document_country: string;
    postal_code: string;
    birth_city: string;
    estimated_monthly_turnover_range: string;
    us_related_person: string;
    pep_related_person: string;
    additional_document_expire_date: string;
    tax_country: string;
    additional_document_number: string;
    person_code: string;
};
export type AccountUserMeta = {
    person: Person;
    title: string;
    id: string;
    updated: string;
    status: AccStatus;
    created: string;
    type: string;
    is_instant_virtual_card_allowed: string;
    kyc_id: string;
    kyc_status: VerificationStatus;
    is_soft_blocked: string;
    is_plastic_card_issuing_forbidden: string;
    is_virtual_card_issuing_forbidden: string;
    is_archived: string;
    is_enabled: string;
    agree_top_up?: boolean;
};
export type Account = {
    id: number;
    accountId: string;
    title: string;
    status: AccStatus | null;
    available: number;
    hold: number;
    total: number;
    created: string;
    updated: string;
    isEnabled: boolean;
    isSoftBlocked: boolean;
    isCardBonded: boolean;
    iban: string;
    minBalanceEnabled: boolean | null;
    minBalance: number | null;
    wallettoTopUpDetails: {
        swift_code: string;
        receiver_name: string;
        payment_details: string;
        bank_name: string;
        bank_address: string;
        registration_number: string;
    }
};
